export enum SeancePath {
  EDITION = 'edition-seance',
  CREATION = 'creation-seance',
  ID_SEANCE_PARAM_MAP = 'IdSeance',
  ID_SESSION_PARAM_MAP = 'IdSession',
  LISTE_SEANCES = 'liste-seances',
  SAISIE_ABSENCES = 'saisie-absences',
  ID_FACTURE_PARAM_MAP = 'IdFacture',
}
